import axios from "axios";
import { url } from "../baseUrl";

export const UserStore = {
  state: {
    profile: {
      address: "",
      city: "",
      country: {},
      email: "",
      fullname: "",
      gender: 0,
      id: "",
      language: {},
      last_login: "",
      phone_number: "",
      role: 3,
      timezone: {},
      title: "",
      username: "",
      company: {
        name: "",
        establish: "",
        website: "",
        owner: "",
        address: "",
        country: {},
        language: {},
        timezone: {},
        email: "",
        phone: ""
      },

      notifications: 0
    },
    tempProfile: {},

    passwordChangeStatus: {
      status: 0,
      text: ""
    }
  },
  mutations: {
    aboutMe(state, data) {
      state.profile = data;
      state.tempProfile = Object.assign({}, data);
      state.tempProfile.company = Object.assign({}, data.company);
    },
    updateProfile(state, data) {
      state.profile = data;
      state.tempProfile = Object.assign({}, data);
      state.tempProfile.company = Object.assign({}, data.company);
    },
    discardProfile(state) {
      state.profile = Object.assign({}, state.tempProfile);
      state.profile.company = Object.assign({}, state.tempProfile.company);
    },
    changePassword(state, data) {
      if (data.status) {
        state.passwordChangeStatus.status = 1;
      } else {
        state.passwordChangeStatus.status = -1;
      }
      state.passwordChangeStatus.text = data.statusText;
    },
    passwordNotMatch(state) {
      state.passwordChangeStatus = {
        status: -1,
        text: "Confirm Password does not Match"
      };
    }
  },
  actions: {
    aboutMe(context) {
      let auth_token = localStorage.getItem("auth_token");
      return new Promise((resolve, reject) => {
        axios({
          url: url.baseUrl + "/accounts/users/me/",
          headers: {
            Authorization: "Token " + auth_token
          },
          method: "GET"
        })
          .then(response => {
            context.commit("aboutMe", response.data);
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    discardProfile(context) {
      context.commit("discardProfile");
    },
    updateProfile(context, data) {
      let auth_token = localStorage.getItem("auth_token");
      return new Promise((resolve, reject) => {
        axios({
          url: url.baseUrl + "/accounts/users/me/",
          headers: {
            Authorization: "Token " + auth_token
          },
          data: data,
          // data: {
          //     'role': data.role,
          //     'fullname': data.fullname,
          //     'gender': data.gender,
          //     'address': data.address,
          //     'city': data.city,
          //     'country': data.country,
          //     'language': data.language,
          //     'timezone': data.timezone,
          //     'title': data.title,
          //     'company': {
          //         'name': data.company.name,
          //         'establish': data.company.establish,
          //         'website': data.company.website,
          //         'owner': data.company.owner,
          //         'address': data.company.address,
          //         'country': data.company.country,
          //         'language': data.company.language,
          //         'timezone': data.company.timezone,
          //         'email': data.company.email,
          //         'phone': data.company.phone,
          //     }
          // },
          method: "POST"
        })
          .then(response => {
            context.commit("updateProfile", response.data);
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    changePassword(context, data) {
      let auth_token = localStorage.getItem("auth_token");
      return new Promise((resolve, reject) => {
        axios({
          url: url.baseUrl + "/accounts/password/change/",
          headers: {
            Authorization: "Token " + auth_token
          },
          data: data,
          method: "POST"
        })
          .then(response => {
            context.commit("changePassword", response.data);
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    passwordNotMatch(context) {
      context.commit("passwordNotMatch");
    }
  },
  getters: {
    register_email: state => {
      return state.profile.email;
    },
    super_admin_id: state => {
      return state.profile.id;
    },
    username: state => {
      return state.profile.username;
    }
  }
};
